export class SearchWorkitemInput{
    public crmUserId:number;
    public sessionToken:string;
    public searchString:string;
    public workItemId:number;
}